// extracted by mini-css-extract-plugin
export default {"mint":"Mint_mint__KgLgA","mint__title":"Mint_mint__title__LAvsF","mint__btn":"Mint_mint__btn__qR+rt","mint__wrap":"Mint_mint__wrap__DTBLP"};